<template>
    <div class="column is-four-fifths" v-if="mainType !== NOTIFICATION_NONE">
        <div class="mb-3">
            <h6 class="is-size-6 has-text-weight-bold mb-3 has-border">
                {{ translateType(mainType) }}
            </h6>
            <p class="mb-3">{{ translate("notification_center.type_notification_content") }}</p>
            <textarea v-model="message" class="textarea" rows="10" :maxlength="getMaxCharsForNotification" />
            <small> {{ translate("notification_center.message_limit") }} {{ getUsedCharsNumber }}/{{ getMaxCharsForNotification }} </small>
        </div>
        <div>
            <button class="button" @click="clearText">
                {{ translate("common.clear") }}
            </button>
        </div>
        <div class="has-text-warning mt-3">
            <span class="icon">
                <i class="fa fa-exclamation-triangle" />
            </span>
            <span>
                {{ translate("notification_center.forbidden_content") }}
            </span>
        </div>
    </div>
    <div v-else class="column is-four-fifths">
        <Notification class="is-danger has-text-centered">
            <span class="icon">
                <i class="fa fa-exclamation-triangle" />
            </span>
            <span>{{ translate("notification_center.choose_notification_type_first") }}</span>
        </Notification>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Notification from "../../Common/Notification";
    import translatorMixin from "../../Common/translatorMixin";
    import SMSHelper from "smshelper";
    import { NOTIFICATION_NONE, NOTIFICATION_SMS } from "../consts";

    const maxCharsForNotification = {
        email: 1000,
        sms: 160,
        internal: 1000,
    };

    export default {
        name: "notification-content-step",
        components: { Notification },
        mixins: [translatorMixin],
        computed: {
            ...mapState("typeOfNotification", ["mainType"]),
            message: {
                set(value) {
                    this.$store.commit("notificationContent/setMessage", value.trim());
                },
                get() {
                    return this.$store.state.notificationContent.message;
                },
            },
            getMaxCharsForNotification() {
                return maxCharsForNotification[this.mainType];
            },
            getUsedCharsNumber() {
                if (this.mainType === NOTIFICATION_SMS) {
                    return SMSHelper.count(this.message);
                }

                return this.message.length;
            },
        },
        created() {
            this.NOTIFICATION_NONE = NOTIFICATION_NONE;
        },
        methods: {
            translateType(type) {
                return this.translate(`notification_center.create.type.` + type);
            },
            clearText() {
                this.message = "";
            },
        },
    };
</script>

<style scoped></style>
